<template>
    <span class="material-icons" :data-type="BLOCK_TYPES.BOT_RESPONSE" v-if="blockType === BLOCK_TYPES.BOT_RESPONSE">
        send
    </span>
    <span class="material-icons" :data-type="BLOCK_TYPES.START_POINT" v-else-if="blockType === BLOCK_TYPES.START_POINT">
        home
    </span>
    <span
        class="material-icons"
        :data-type="BLOCK_TYPES.ATTACHMENT_INPUT"
        v-else-if="blockType === BLOCK_TYPES.ATTACHMENT_INPUT"
    >
        attachment
    </span>
    <span class="material-icons" :data-type="BLOCK_TYPES.FILTER" v-else-if="blockType === BLOCK_TYPES.FILTER">
        filter_alt
    </span>
    <span class="material-icons" :data-type="BLOCK_TYPES.USER_INPUT" v-else-if="blockType === BLOCK_TYPES.USER_INPUT">
        record_voice_over
    </span>
    <span class="material-icons" :data-type="BLOCK_TYPES.GO_TO_STEP" v-else-if="blockType === BLOCK_TYPES.GO_TO_STEP">
        cable
    </span>
    <span
        class="material-icons"
        :data-type="BLOCK_TYPES.ADD_TO_SEGMENT"
        v-else-if="blockType === BLOCK_TYPES.ADD_TO_SEGMENT"
    >
        pie_chart
    </span>
    <span
        class="material-icons"
        :data-type="BLOCK_TYPES.REMOVE_FROM_SEGMENT"
        v-else-if="blockType === BLOCK_TYPES.REMOVE_FROM_SEGMENT"
    >
        pie_chart
    </span>
    <span
        class="material-icons"
        :data-type="BLOCK_TYPES.DEFAULT_FALLBACK"
        v-else-if="blockType === BLOCK_TYPES.DEFAULT_FALLBACK"
    >
        heart_broken
    </span>
    <span class="material-icons" :data-type="BLOCK_TYPES.FALLBACK" v-else-if="blockType === BLOCK_TYPES.FALLBACK">
        heart_broken
    </span>
    <span class="material-icons" :data-type="BLOCK_TYPES.QUESTION" v-else-if="blockType === BLOCK_TYPES.QUESTION">
        quiz
    </span>
    <span
        class="material-icons"
        :data-type="BLOCK_TYPES.SET_ATTRIBUTE"
        v-else-if="blockType === BLOCK_TYPES.SET_ATTRIBUTE"
    >
        data_object
    </span>
    <span class="material-icons" :data-type="BLOCK_TYPES.CLOSE_CHAT" v-else-if="blockType === BLOCK_TYPES.CLOSE_CHAT">
        mark_chat_read
    </span>
    <span class="material-icons" :data-type="BLOCK_TYPES.SUCCESS" v-else-if="blockType === BLOCK_TYPES.SUCCESS">
        check_circle
    </span>
    <span class="material-icons" :data-type="BLOCK_TYPES.FAILURE" v-else-if="blockType === BLOCK_TYPES.FAILURE">
        cancel
    </span>
    <span class="material-icons" :data-type="BLOCK_TYPES.FLOW" v-else-if="blockType === BLOCK_TYPES.FLOW">schema</span>
    <span
        class="material-icons"
        :data-type="BLOCK_TYPES.CREATE_TICKET"
        v-else-if="blockType === BLOCK_TYPES.CREATE_TICKET"
    >
        local_activity
    </span>
    <span class="material-icons" :data-type="BLOCK_TYPES.TAG_CHAT" v-else-if="blockType === BLOCK_TYPES.TAG_CHAT">
        bookmark
    </span>
    <span class="material-icons" :data-type="BLOCK_TYPES.REMOVE_TAG" v-else-if="blockType === BLOCK_TYPES.REMOVE_TAG">
        bookmark_remove
    </span>
    <span
        class="material-icons"
        :data-type="BLOCK_TYPES.TRANSFER_CHAT"
        v-else-if="blockType === BLOCK_TYPES.TRANSFER_CHAT"
    >
        support_agent
    </span>
    <span
        class="material-icons"
        :data-type="BLOCK_TYPES.SEND_TRANSCRIPT"
        v-else-if="blockType === BLOCK_TYPES.SEND_TRANSCRIPT"
    >
        attach_email
    </span>
    <span class="material-icons" :data-type="BLOCK_TYPES.SEND_SMS" v-else-if="blockType === BLOCK_TYPES.SEND_SMS">
        sms
    </span>
    <span class="material-icons" :data-type="BLOCK_TYPES.SEND_MAIL" v-else-if="blockType === BLOCK_TYPES.SEND_MAIL">
        mail
    </span>
    <span
        class="material-icons text-light"
        :data-type="BLOCK_TYPES.WEBHOOK"
        v-else-if="blockType === BLOCK_TYPES.WEBHOOK"
    >
        share
    </span>
    <span
        class="material-icons"
        :data-type="BLOCK_TYPES.GET_LOCATION"
        v-else-if="blockType === BLOCK_TYPES.GET_LOCATION"
    >
        location_on
    </span>
    <span
        class="material-icons"
        :data-type="BLOCK_TYPES.SET_DEPARTMENT"
        v-else-if="blockType === BLOCK_TYPES.SET_DEPARTMENT"
    >
        category
    </span>
    <img
        class="custom-block-logo"
        src="/static/img/akinon.png"
        :data-type="blockType"
        v-else-if="BLOCK_TYPES.AKINON_BLOCKS.includes(blockType)"
    />

    <img
        class="custom-block-logo"
        src="/static/img/chatbot/probel.png"
        :data-type="blockType"
        v-else-if="BLOCK_TYPES.PROBEL_BLOCKS.includes(blockType)"
    />

    <img
        class="custom-block-logo"
        src="/static/img/chatbot/kipas.png"
        :data-type="blockType"
        v-else-if="BLOCK_TYPES.KIPAS_BLOCKS.includes(blockType)"
    />

    <img
        class="custom-block-logo"
        src="/static/img/shopify.png"
        :data-type="BLOCK_TYPES.SHOPIFY_ORDER_STATUS"
        v-else-if="blockType === BLOCK_TYPES.SHOPIFY_ORDER_STATUS"
    />
    <img
        class="custom-block-logo"
        src="/static/img/shopify.png"
        :data-type="BLOCK_TYPES.SHOPIFY_PRODUCT_AVAILABILITY"
        v-else-if="blockType === BLOCK_TYPES.SHOPIFY_PRODUCT_AVAILABILITY"
    />
    <img
        class="custom-block-logo"
        src="/static/img/shopify.png"
        :data-type="BLOCK_TYPES.SHOPIFY_SHOW_PRODUCTS"
        v-else-if="blockType === BLOCK_TYPES.SHOPIFY_SHOW_PRODUCTS"
    />
    <img
        class="custom-block-logo"
        src="/static/img/openai.png"
        :data-type="BLOCK_TYPES.AI_BOT_RESPONSE"
        v-else-if="blockType === BLOCK_TYPES.AI_BOT_RESPONSE"
    />
    <div
        class="custom-block-logo ai-assistant"
        v-else-if="blockType === BLOCK_TYPES.AI_ASSISTANT"
        :data-type="BLOCK_TYPES.AI_ASSISTANT"
    >
        <OpenaiIcon />
    </div>
</template>

<script>
import BLOCK_TYPES from "../../../block.types";
import OpenaiIcon from "../../integrations/svg/OpenaiIcon.vue";

export default {
    name: "BlockIconPreview",
    components: { OpenaiIcon },
    props: {
        blockType: {
            type: String,
            required: false,
            default: "",
        },
    },
    data: function () {
        return {
            BLOCK_TYPES,
        };
    },
};
</script>

<style lang="scss">
.material-icons {
    &[data-type="BOT_RESPONSE"] {
        transform: rotate(-40deg);
    }

    &[data-type="FLOW"] {
        transform: rotate(180deg);
    }

    &[data-type="ATTACHMENT_INPUT"] {
        transform: rotate(-45deg);
    }

    &[data-type="GO_TO_STEP"] {
        color: red;
        transform: rotate(87deg);
    }

    &[data-type="ADD_TO_SEGMENT"] {
        color: #22314a;
    }

    &[data-type="REMOVE_FROM_SEGMENT"] {
        color: #22314a;
    }

    &[data-type="SET_DEPARTMENT"] {
        color: white;
        background-color: #f30879 !important;
        border-radius: 50%;
        padding: 2px;
    }
}

.custom-block-logo {
    background: none !important;

    &[data-type="AI_ASSISTANT"] {
        border-radius: 50%;
        padding: 2px;

        svg {
            width: 20px;
            height: 20px;
            fill: #fff;

            g {
                fill: #fff !important;
            }
        }
    }
}
</style>
